import { LessonLike } from '@/helpers/types/LessonLike';

export const countLessons = (
    lessons: LessonLike | LessonLike[],
    checkFunction?: (l: LessonLike) => boolean
): number => {
    const list = Array.isArray(lessons) ? lessons : [lessons];

    let total = 0;

    for (const lesson of list) {
        const shouldCount = checkFunction ? checkFunction(lesson) : true;
        if (shouldCount) {
            total += 1;
        }

        if (lesson.sub_lessons && lesson.sub_lessons.length > 0) {
            total += countLessons(lesson.sub_lessons, checkFunction);
        }
    }

    return total;
};
